import { noopReturn } from '@motionone/utils';
var timeStep = 10;
var maxDuration = 10000;
function pregenerateKeyframes(generator) {
  var toUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noopReturn;
  var overshootDuration = undefined;
  var timestamp = timeStep;
  var state = generator(0);
  var keyframes = [toUnit(state.current)];
  while (!state.done && timestamp < maxDuration) {
    state = generator(timestamp);
    keyframes.push(toUnit(state.done ? state.target : state.current));
    if (overshootDuration === undefined && state.hasReachedTarget) {
      overshootDuration = timestamp;
    }
    timestamp += timeStep;
  }
  var duration = timestamp - timeStep;
  /**
   * If generating an animation that didn't actually move,
   * generate a second keyframe so we have an origin and target.
   */
  if (keyframes.length === 1) keyframes.push(state.current);
  return {
    keyframes: keyframes,
    duration: duration / 1000,
    overshootDuration: (overshootDuration !== null && overshootDuration !== void 0 ? overshootDuration : duration) / 1000
  };
}
export { pregenerateKeyframes };